import React from "react";
import { Empty, Steps, Descriptions, Spin } from "antd";
import moment from "moment-jalaali";
import StringHelper from "../../helpers/StringHelper";
import { ClockCircleOutlined, UserOutlined, SolutionOutlined } from '@ant-design/icons';
import { useReportsStore } from "../../../store/slices/createReportsSlice";


const { Step } = Steps;
export default function DeliveryStateHistory() {
    const reports = useReportsStore()
    const faNum = StringHelper.getFarsiNum;
    const info = reports.deliveryStateHistory.data;
    const loading = reports.deliveryStateHistory.loading;

    return (
        <Spin spinning={loading}> <div className="collapse-style">
            {info && <Descriptions className="deliveryStateHistory-label" >
                {info.ReceiverFullName && <Descriptions.Item label="نام تحویل  گیرنده ">
                    {faNum(info.ReceiverFullName)}
                </Descriptions.Item>}
                {info.ShippingCode && <Descriptions.Item label="کد مرسوله ">
                    {faNum(info.ShippingCode)}
                </Descriptions.Item>}
                {info.ReceiverPhone && <Descriptions.Item label="شماره تماس    ">
                    {faNum(info.ReceiverPhone)}
                </Descriptions.Item>}
                {info.DeliveryDate && <Descriptions.Item label="تاریخ تحویل ">
                    {faNum(
                        moment(info.DeliveryDate).format(
                            'jYYYY/jM/jD'
                        ))}
                </Descriptions.Item>}
                {info.DeliveryTimeTitle && <Descriptions.Item label="زمان تحویل">
                    {faNum(info.DeliveryTimeTitle)}
                </Descriptions.Item>}
            </Descriptions>}
            {info && <Descriptions className="deliveryStateHistory-label" >
                {info.Address && <Descriptions.Item label="آدرس">
                    {faNum(info.Address)}
                </Descriptions.Item>}
            </Descriptions>}
            {info && info.DeliveryStateItems ?
                info.DeliveryStateItems.map((item, index) => {
                    return (
                        <div className="deliverystate-style" key={index}>
                            <Steps >
                                <Step title={item.SubmitterFullName} status="finish" icon={<UserOutlined />} />
                                <Step title={item.StateTitle} status="finish" icon={<SolutionOutlined />} />
                                <Step title={faNum(
                                    moment(item.DateTime).format(
                                        'jYYYY/jM/jD - HH:mm  '
                                    )
                                )} status="finish" icon={<ClockCircleOutlined />} />
                            </Steps>
                        </div>
                    );
                }) : <Empty description={false} />
            }
        </div></Spin>
    );
}


